module.exports = __webpack_public_path__ + "img/logo_1.92a23df0.png";